import React from "react";
import { Link } from "react-router-dom";
import "./Homepage.css";

import baseball from '../Images/blaineBaseball.jpg';
import teamGym from '../Images/team-gym.jpg';
import wellnessTraining from '../Images/wellness-training.jpg';

const highlights = [
  {
    title: "1-on-1 In-Person Physical Therapy",
    body:
      "At Harteis Physical Therapy & Sports Performance, you'll always work directly 1-on-1 with your physical therapist — no being passed off to aides or techs. Our clinic is modern, fully equipped with high-quality training equipment and designed to give you the focused care you deserve.\n\nYour first session includes a comprehensive evaluation where we take the time to understand your pain levels, medical history, past injuries or surgeries, and the sports and activities that matter most to you. From there, we'll create a personalized recovery plan that gets you back to moving confidently and doing what you love.\n\nFollow-up visits are centered around targeted rehab exercises, mobility training, and strength work to support your overall health and performance. Depending on your needs, sessions may also include hands-on treatments such as soft tissue work, dry needling, cupping, taping, or soft tissue mobilization.",
    image: teamGym,
    imageAlt: "Dr. Blaine Harteis with a client at High Street Body Shop",
    imageSide: "left",
    imageAspect: "4 / 5",
  },
  {
    title: "General Wellness Training",
    body:
      "At Harteis Physical Therapy and Sports Performance, every session is designed to help you feel better, move better, and live better. If your goals include weight loss, improving heart health, boosting mobility, or simply having more energy for daily life, we'll create a plan that's right for you. Our mission is to help you stay strong, healthy, and ready for any activity you love — so you can enjoy life at your best.",
    image: wellnessTraining,
    imageAlt: "A client working on balance training at Harteis Physical Therapy",
    imageAspect: "4 / 5",
  },
  {
    title: "Sports Performance Training",
    body:
      "At Harteis Physical Therapy & Sports Performance, we help athletes of all levels — from competitive players to weekend warriors — unlock their full potential. Whether you want to increase speed, build strength, improve explosiveness, enhance mobility, or gain that extra edge in competition, we'll create a plan to get you there. We offer personalized 1-on-1 sessions, small group training, and even full team programs.",
    image: baseball,
    imageAlt: "Dr. Blaine Harteis",
    imageSide: "left",
  },
];

export default function Homepage() {
  return (
    <main className="Homepage">
      <section className="hero hero-centered">
        <div className="hero-copy">
          <p className="section-eyebrow">Harteis Physical Therapy &amp; Sports Performance</p>
          <h1>Recover Stronger. Move Better. Perform Higher.</h1>
          <p className="hero-sub">
            Personalized, 1-on-1 physical therapy and sports performance training —
            built around your goals, not an insurance checklist.
          </p>
          <div className="hero-actions">
            <Link to="/Contact" className="btn btn-primary">Book a Visit</Link>
            <Link to="/Services" className="btn btn-secondary">View Services</Link>
          </div>
        </div>
      </section>

      <section className="highlights">
        {highlights.map((item) => (
          <article
            className={`card highlight-card ${item.image ? "highlight-card-media" : ""} ${item.imageSide === "left" ? "highlight-card-media-left" : ""}`}
            key={item.title}
          >
            <div className="highlight-card-copy">
              <h2 className="title">{item.title}</h2>
              {item.body.split("\n\n").map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
            {item.image && (
              <div
                className="highlight-card-image"
                style={item.imageAspect ? { aspectRatio: item.imageAspect } : undefined}
              >
                <img src={item.image} alt={item.imageAlt} loading="lazy" />
              </div>
            )}
          </article>
        ))}
      </section>

      <section className="cta-band card">
        <h2>Ready to get back to what you love?</h2>
        <p>Schedule your first evaluation and let's build a plan around your goals.</p>
        <Link to="/Contact" className="btn btn-primary">Get In Touch</Link>
      </section>
    </main>
  );
}
